module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Select bibliographies")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("General introduction to Haggai, Zechariah and Malachi")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Baldwin, J. G. (1972), "), _c('i', [_vm._v("Haggai, Zechariah and Malachi")]), _vm._v(", TOTC 28 (London/Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Berquist, J. L. (1995), "), _c('i', [_vm._v("Judaism in Persia’s Shadow ")]), _vm._v("(Minneapolis: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Collins, T. (1993), ‘The Scroll of the Twelve’, in "), _c('i', [_vm._v("The Mantle of Elijah")]), _vm._v(", BibSem 20 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Dumbrell, W. J. (2002), "), _c('i', [_vm._v("The Faith of Israel")]), _vm._v(", 2nd edn (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Firth, D. G. and Paul D. Wegner (eds.) (2011), "), _c('i', [_vm._v("Presence, Power and Promise: The Role of the Spirit of God in the Old Testament")]), _vm._v(" (Nottingham: Apollos; Downers Grove: IVP Academic).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Gottwald, N. K. (1985), ‘Tragedy and Comedy in the Latter Prophets’, "), _c('i', [_vm._v("Semeia ")]), _vm._v("32: 83–96.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Hanson, P. D. (1992), ‘Messiahs and Messianic Figures in Proto-Apocalypticism’, in J. H. Charlesworth (ed.), "), _c('i', [_vm._v("The Messiah: Developments in Earliest Judaism and Christianity ")]), _vm._v("(Minneapolis: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Hill, A. E. (1998), "), _c('i', [_vm._v("Malachi")]), _vm._v(", AB 25D (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("House, P. (1990), "), _c('i', [_vm._v("The Unity of the Twelve")]), _vm._v(", JSOTSup 97 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Merrill, E. H. (1994), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi ")]), _vm._v("(Chicago: Moody).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Patterson, R. D. and A. E. Hill (2008), "), _c('i', [_vm._v("Minor Prophets: Hosea – Malachi")]), _vm._v(", CorBC 10 (Wheaton, Ill.: Tyndale House).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Petersen, D. L. (2000), ‘A Book of the Twelve?’, in J. D. Nogalski and M. A. Sweeney (eds.), "), _c('i', [_vm._v("Reading and Hearing the Book of the Twelve")]), _vm._v(", Symp 15 (Atlanta: SBL).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Redditt, P. L. and A. Schart (2003), "), _c('i', [_vm._v("Thematic Threads in the Book of the Twelve")]), _vm._v(", BZAW 325 (Berlin: de Gruyter).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Rose, W. H. (2000), "), _c('i', [_vm._v("Zemah and Zerubbabel: Messianic Expectations in the Early Postexilic Period")]), _vm._v(", JSOTSup 304 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Tollington, J. E. (1993), "), _c('i', [_vm._v("Tradition and Innovation in Haggai and Zechariah 1 – 8")]), _vm._v(", JSOTSup 150 (Sheffield: JSOT Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Walton, J. H. and A. E. Hill (2004), "), _c('i', [_vm._v("Old Testament Today ")]), _vm._v("(Grand Rapids: Zondervan).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Haggai")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Achtemeier, E. (1986), "), _c('i', [_vm._v("Nahum – Malachi")]), _vm._v(", Int (Atlanta: John Knox).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Baldwin, J. G. (1972), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi")]), _vm._v(", TOTC 28 (London/Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Berquist, J. L. (1995), "), _c('i', [_vm._v("Judaism in Persia’s Shadow ")]), _vm._v("(Minneapolis: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Boda, M. J. (2000), ‘Haggai: Master Rhetorician’, "), _c('i', [_vm._v("TynB ")]), _vm._v("51: 295–304.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("––– (2004), "), _c('i', [_vm._v("Haggai, Zechariah")]), _vm._v(", NIVAC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("––– (2007), ‘Messengers of Hope in Haggai – Malachi’, "), _c('i', [_vm._v("JSOT ")]), _vm._v("32: 113–131.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Briant, P. (2002), "), _c('i', [_vm._v("From Cyrus to Alexander: A History of the Persian Empire")]), _vm._v(", trans. P. T. Daniels (Winona Lake: Eisenbrauns).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Christensen, D. L. (1992), ‘Impulse and Design in the Book of Haggai’, "), _c('i', [_vm._v("JETS ")]), _vm._v("35: 445–456.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Clements, R. E. (1965), "), _c('i', [_vm._v("God and Temple ")]), _vm._v("(Philadelphia: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Coats, G. W. and B. O. Long (eds.) (1977), "), _c('i', [_vm._v("Canon and Authority ")]), _vm._v("(Philadelphia: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Craig, K. M. (1996), ‘Interrogatives in Haggai – Zechariah: A Literary Thread?’, in "), _c('i', [_vm._v("Forming Prophetic Literature: Essays on Isaiah and the Twelve in Honor of John D. W. Watts")]), _vm._v(", JSOTSup 235 (Sheffield: Sheffield Academic Press), 224–244.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Craigie, P. C. (1985), "), _c('i', [_vm._v("The Twelve Prophets")]), _vm._v(", DSBOT, vol. 2 (Philadelphia: Westminster).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Dumbrell, W. J. (2002), "), _c('i', [_vm._v("The Faith of Israel")]), _vm._v(", 2nd edn (Grand ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Rapids: Baker; Leicester: Apollos).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Ferreiro, A. (ed.) (2003), "), _c('i', [_vm._v("Ancient Christian Commentary on Scripture")]), _vm._v(", vol. 14 (Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Floyd, M. H. (2000), "), _c('i', [_vm._v("Minor Prophets: Part 2")]), _vm._v(", FOTL XXII (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Goldingay, J. (2006), "), _c('i', [_vm._v("Old Testament Theology: Israel’s Faith ")]), _vm._v("(Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Gowan, D. E. (1986), "), _c('i', [_vm._v("Eschatology in the Old Testament ")]), _vm._v("(Philadelphia: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Hildebrand, D. R. (1989), ‘Temple Ritual: A Paradigm for Moral Holiness in Haggai II 10–19’, "), _c('i', [_vm._v("VT ")]), _vm._v("39: 154–168.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Hill, A. E. (1998), "), _c('i', [_vm._v("Malachi")]), _vm._v(", AB 25D (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("––– (2003), "), _c('i', [_vm._v("1 & 2 Chronicles")]), _vm._v(", NIVAC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Jones, B. A. (1995), "), _c('i', [_vm._v("The Formation of the Book of the Twelve: A Study in Text and Canon, ")]), _vm._v("SBLDS 149 (Atlanta: Scholars Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Kaiser, W. C. (1995), "), _c('i', [_vm._v("The Messiah in the Old Testament ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Kessler, J. A. (2002), "), _c('i', [_vm._v("The Book of Haggai: Prophecy and Society in Early Persian Yehud")]), _vm._v(", VTSup 91 (Leiden: Brill).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("March, W. E. (1996), in L. E. Keck (ed.), "), _c('i', [_vm._v("The New Interpreter’s Bible")]), _vm._v(", vol. 7 (Nashville: Abingdon), 707–732.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Martens, E. A. (1994), "), _c('i', [_vm._v("God’s Design: A Focus on Old Testament Theology")]), _vm._v(", 2nd edn (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Mason, R. (1977), "), _c('i', [_vm._v("The Books of Haggai, Zechariah and Malachi ")]), _vm._v("(Cambridge: Cambridge University Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Merrill, E. H. (1994), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi: An Exegetical Commentary ")]), _vm._v("(Chicago: Moody).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("––– (2008), ‘Haggai’, in T. Longman and D. Garland (eds.), "), _c('i', [_vm._v("The Expositor’s Bible Commentary")]), _vm._v(", rev. edn, vol. 8 (Grand Rapids: Zondervan), 699–720.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Meyers, E. M. and C. L. Meyers (1987), "), _c('i', [_vm._v("Haggai, Zechariah 1 – 8")]), _vm._v(", AB 25B (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Motyer, J. A. (1998), ‘Haggai’, in T. E. McComiskey (ed.), "), _c('i', [_vm._v("The Minor Prophets")]), _vm._v(", vol. 3 (Grand Rapids: Baker), 963–1002.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Neusner, J. (2007), "), _c('i', [_vm._v("Zephaniah, Haggai, Zechariah and Malachi in Talmud and Midrash ")]), _vm._v("(New York: University of America Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Nogalski, J. (1993), "), _c('i', [_vm._v("Literary Precursors to the Book of the Twelve")]), _vm._v(", BZAW 217 (Berlin: Walter de Gruyter).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Patrick, F. Y. (2008), ‘Time and Tradition in the Book of Haggai’, in M. J. Boda and M. H. Floyd (eds.), "), _c('i', [_vm._v("Tradition in Transition")]), _vm._v(": "), _c('i', [_vm._v("Haggai and Zechariah 1 – 8 in the Trajectory of Hebrew Theology ")]), _vm._v("(New York: T. & T. Clark), 40–55.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Petersen, D. L. (1984), "), _c('i', [_vm._v("Haggai and Zechariah 1 – 8")]), _vm._v(", OTL (Philadelphia: Westminster).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Pierce, R. W. (1984), ‘Literary Connectors and a Haggai/Zechariah/Malachi Corpus’, "), _c('i', [_vm._v("JETS ")]), _vm._v("27: 277–289.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("––– (1984), ‘A Thematic Development in the Haggai/Zechariah/Malachi Corpus’, "), _c('i', [_vm._v("JETS ")]), _vm._v("27: 401–411.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Redditt, P. L. (1995), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi")]), _vm._v(", NCBC (London: Marshall Pickering).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("––– (2007), ‘Themes in Haggai, Zechariah, Malachi’, "), _c('i', [_vm._v("Int ")]), _vm._v("61: 184–197.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Rose, W. H. (2000), "), _c('i', [_vm._v("Zemah and Zerubbabel: Messianic Expectations in the Early Postexilic Period")]), _vm._v(", JSOTSup 304 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Smith, J. M. P. in H. G. Mitchell, J. M. P. Smith and J. A. Bewer (1912), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi and Jonah")]), _vm._v(", ICC (Edinburgh: T. & T. Clark).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Smith, R. L. (1984), "), _c('i', [_vm._v("Micah – Malachi")]), _vm._v(", WBC 32 (Waco: Word).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Stuhlmueller, C. (1988), "), _c('i', [_vm._v("Haggai & Zechariah: Rebuilding with Hope")]), _vm._v(", ITC (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Sweeney, M. A. (2000), "), _c('i', [_vm._v("The Twelve Prophets")]), _vm._v(", Berit Olam, vol. 2 (Collegeville, Minn.: Liturgical Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Taylor, R. A. and E. R. Clendenen (2004), "), _c('i', [_vm._v("Haggai, Malachi")]), _vm._v(", NAC 21A (Nashville: Broadman & Holman).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Terrien, S. (1978), "), _c('i', [_vm._v("The Elusive Presence ")]), _vm._v("(New York: Harper & Row).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Thomas, D. W. (1956), ‘Haggai’, in G. A. Buttrick (ed.), "), _c('i', [_vm._v("The Interpreter’s Bible")]), _vm._v(", vol. 6 (Nashville: Abingdon), 1036–1049.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Tucker, G. M. (1977), ‘Prophetic Superscriptions and the Growth of a Canon’, in G. W. Coats and B. O. Long (eds.), "), _c('i', [_vm._v("Canon and Authority ")]), _vm._v("(Philadelphia: Fortress), 56–70.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Verhoef, P. A. (1987), "), _c('i', [_vm._v("Haggai and Malachi")]), _vm._v(", NICOT (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Wolf, H. (1976), "), _c('i', [_vm._v("Haggai and Malachi")]), _vm._v(", EvBC (Chicago: Moody).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Wolff, H. W. (1988), "), _c('i', [_vm._v("Haggai: A Commentary")]), _vm._v(", trans. M. Kohl (Minneapolis: Augsburg).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Yamauchi, E. M. (1990), "), _c('i', [_vm._v("Persia and the Bible ")]), _vm._v("(Grand Rapids: Baker).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Zechariah")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Achtemeier, E. (1986), "), _c('i', [_vm._v("Nahum – Malachi")]), _vm._v(", Int (Atlanta: John Knox).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Andersen, F. I. and D. N. Freedman (1980), "), _c('i', [_vm._v("Hosea")]), _vm._v(", AB 24 (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Bahat, D. (1990), "), _c('i', [_vm._v("The Illustrated Atlas of Jerusalem")]), _vm._v(", trans. S. Ketko (Jerusalem: CARTA).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Baldwin, J. G. (1972), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi")]), _vm._v(", TOTC 28 (London/Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Baly, D. (1974), "), _c('i', [_vm._v("The Geography of the Bible")]), _vm._v(", rev. edn (New York: Harper & Row).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Barker, K. L. (2008), ‘Zechariah’, in T. Longman and D. E. Garland (eds.), "), _c('i', [_vm._v("The Expositor’s Bible Commentary")]), _vm._v(", rev. edn, vol. 8 (Grand Rapids: Zondervan), 723–833.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Blenkinsopp, J. (1998), ‘The Judean Priesthood During the Neo-Babylonian and Achaemenid Periods: A Hypothetical Reconstruction’, "), _c('i', [_vm._v("CBQ ")]), _vm._v("60: 25–43.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Boda, M. J. (2004), "), _c('i', [_vm._v("Haggai, Zechariah")]), _vm._v(", NIVAC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Brosius, M. (1998), "), _c('i', [_vm._v("Women In Ancient Persia (559–331 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") ")]), _vm._v("(Oxford: Clarendon Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Butterworth, M. (1992), "), _c('i', [_vm._v("The Structure of Zechariah")]), _vm._v(", JSOTSup 130 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Calvin, J. (1979), "), _c('i', [_vm._v("Commentaries on the Twelve Minor Prophets ")]), _vm._v("(repr.), trans. J. Owen, vol. 15 (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Cathcart, K. J. and R. P. Gordon (1989), "), _c('i', [_vm._v("The Targum of the Minor Prophets")]), _vm._v(", The Aramaic Bible 14 (Wilmington, Del.: Michael Glazier).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Childs, B. S. (1979), "), _c('i', [_vm._v("Introduction to the Old Testament as Scripture ")]), _vm._v("(Philadelphia: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Clifford, R. J. (1972), "), _c('i', [_vm._v("The Cosmic Mountain in Canaan and in the Old Testament")]), _vm._v(", HSM 4 (Cambridge: Harvard University Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Cook, S. L. (1995), "), _c('i', [_vm._v("Prophecy & Apocalypticism: The Postexilic Social Setting ")]), _vm._v("(Minneapolis: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Craigie, P. C. (1985), "), _c('i', [_vm._v("Twelve Prophets")]), _vm._v(", DSBOT, vol. 2 (Philadelphia: Westminster).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Dorsey, D. A. (1999), "), _c('i', [_vm._v("The Literary Structure of the Old Testament ")]), _vm._v("(Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Eichrodt, W. (1967), "), _c('i', [_vm._v("Theology of the Old Testament")]), _vm._v(", OTL, vol. 1 (Philadelphia: Westminster).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Fishbane, M. (1985), "), _c('i', [_vm._v("Biblical Interpretation in Ancient Israel ")]), _vm._v("(Oxford: Clarendon Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Frost, S. B. (1952), "), _c('i', [_vm._v("Old Testament Apocalyptic, Its Origins and Growth ")]), _vm._v("(London: Epworth).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Hanson, P. D. (1979), "), _c('i', [_vm._v("The Dawn of Apocalyptic")]), _vm._v(", rev. edn (Philadelphia: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("––– (1987), "), _c('i', [_vm._v("Old Testament Apocalyptic ")]), _vm._v("(Nashville: Abingdon).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Harrington, H. K. (2002), ‘Zechariah’, in C. C. Kroeger and M. J. Evans (eds.), "), _c('i', [_vm._v("The IVP Women’s Bible Commentary ")]), _vm._v("(Downers Grove: IVP), 491–500.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Hill, A. E. (1982), ‘Dating “Second Zechariah”: A Linguistic Reexamination’, "), _c('i', [_vm._v("HAR ")]), _vm._v("6: 105–134.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("––– (1998), "), _c('i', [_vm._v("Malachi")]), _vm._v(", AB 25D (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("––– (2008), "), _c('i', [_vm._v("Hosea – Malachi")]), _vm._v(", CBC 10 (Wheaton: Tyndale).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Jeremias, C. (1977), "), _c('i', [_vm._v("Die Nachtgesichte des Sacharja: Untersuchungen zu ihrer Stellung im Zusammenhand der Visionsberichte im Alten Testament und zu ihrem Bildmaterial")]), _vm._v(", FRLANT 117 (Göttingen: Vandenhoeck & Ruprecht).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Jones, B. A. (1995), "), _c('i', [_vm._v("The Formation of the Book of the Twelve: A Study in Text and Canon")]), _vm._v(", SBLDS 149 (Atlanta: Scholars Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Jones, D. R. (1962), ‘A Fresh Interpretation of Zechariah IX–XI’, "), _c('i', [_vm._v("VT ")]), _vm._v("12: 241–259.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Kaiser, W. C. (1995), "), _c('i', [_vm._v("The Messiah in the Old Testament ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("––– (2000), "), _c('i', [_vm._v("Mission in the Old Testament ")]), _vm._v("(Grand Rapids: Baker Books).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Lacocque, A. (1981), "), _c('i', [_vm._v("Zacharie 9 – 14")]), _vm._v(", CAT XIc (Neuchâtel/Paris: Delachaux & Niestlé).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Larkin, K. (1994), "), _c('i', [_vm._v("The Eschatology of Second Zechariah ")]), _vm._v("(Kampen: Kok Pharos).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Lind, M. C. (1980), "), _c('i', [_vm._v("Yahweh Is a Warrior ")]), _vm._v("(Scottdale, Penn.: Herald Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Longman, T. and R. B. Dillard (2006), "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(", 2nd edn (Grand Rapids: Zondervan; ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Nottingham: Apollos).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Longman, T. and D. G. Reid (1995), "), _c('i', [_vm._v("God Is a Warrior ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Luther, M. (1973), "), _c('i', [_vm._v("Lectures on Minor Prophets: Zechariah")]), _vm._v(", in H. C. Oswald (ed.), trans. R. J. Dinda, vol. 20 (St Louis: Concordia).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Mason, R. (1977), "), _c('i', [_vm._v("The Books of Haggai, Zechariah and Malachi ")]), _vm._v("(Cambridge: Cambridge University Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("––– (1984), ‘Some Echoes of the Preaching in the Second Temple? Tradition Elements in Zechariah 1 – 8’, "), _c('i', [_vm._v("ZAW ")]), _vm._v("96: 221–235.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("––– (1990), "), _c('i', [_vm._v("Preaching the Tradition: Homily and Hermeneutics after the Exile ")]), _vm._v("(Cambridge: Cambridge University Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("––– (2003), ‘The Use of Earlier Biblical Material in Zechariah 9 – 14: A Study in Inner Biblical Exegesis’, in M. J. Boda and M. H. Floyd (eds.), "), _c('i', [_vm._v("Bringing Out the Treasure: Inner Biblical Allusion and Zechariah 9 – 14")]), _vm._v(", JSOTSup 304 (Sheffield: Sheffield Academic Press), 7–208.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("McComiskey, T. E. (1998), ‘Zechariah’, in T. E. McComiskey (ed.), "), _c('i', [_vm._v("The Minor Prophets")]), _vm._v(", vol. 3 (Grand Rapids: Baker), 1003–1244.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Merrill, E. H. (1994), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi ")]), _vm._v("(Chicago: Moody Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Meyers, C. L. and E. M. Meyers (1987), "), _c('i', [_vm._v("Haggai, Zechariah 1 – 8")]), _vm._v(", AB 25B (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("––– (1993), "), _c('i', [_vm._v("Zechariah 9 – 14")]), _vm._v(", AB 25C (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("––– (1994), ‘Demography and Diatribes: Yehud’s Population and the Prophecy of Second Zechariah’, in M. D. Coogan et al. (eds.), "), _c('i', [_vm._v("Scripture and Other Artifacts: Essays in Honor of Philip J. King ")]), _vm._v("(Louisville: Westminster John Knox), 268–285.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Miller, P. D. (1973), "), _c('i', [_vm._v("The Divine Warrior in Early Israel ")]), _vm._v("(Cambridge: Harvard University Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Moo, D. J. (1998), "), _c('i', [_vm._v("The Epistle to the Romans")]), _vm._v(", NICNT (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Nurmela, R. (1996), "), _c('i', [_vm._v("Prophets in Dialogue: Inner-Biblical Allusions in Zechariah 1 – 8 and 9 – 14 ")]), _vm._v("(Åbo: Åbo Akademi University).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("O’Brien, J. M. (2004), "), _c('i', [_vm._v("Nahum, Habakkuk, Zephaniah, Haggai, Zechariah, Malachi")]), _vm._v(", AOTC (Nashville: Abingdon).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Ollenburger, B. C. (1996), ‘Zechariah’, in L. E. Keck (ed.), "), _c('i', [_vm._v("The New Interpreter’s Bible")]), _vm._v(", vol. 7 (Nashville: Abingdon), 735–840.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Petersen, D. L. (1984), "), _c('i', [_vm._v("Haggai and Zechariah 1 – 8")]), _vm._v(", OTL (Philadelphia: Westminster).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("––– (1995), "), _c('i', [_vm._v("Zechariah 9 – 14 and Malachi")]), _vm._v(", OTL (Louisville: Westminster John Knox Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Pierce, R. W. (1984), ‘Literary Connectors and a Haggai-Zechariah-Malachi Corpus’, "), _c('i', [_vm._v("JETS ")]), _vm._v("27: 277–289.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Radday, Y. T. and D. Wickman (1975), ‘The Unity of Zechariah Examined in Light of Statistical Linguistics’, "), _c('i', [_vm._v("ZAW ")]), _vm._v("87: 30–55.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Redditt, P. L. (1995), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi")]), _vm._v(", NCBC (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Rose, W. H. (2000), "), _c('i', [_vm._v("Zemah and Zerubbabel: Messianic Expectation in the Early Postexilic Period")]), _vm._v(", JSOTSup 304 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Routledge, R. (2008), "), _c('i', [_vm._v("Old Testament Theology: A Thematic Approach ")]), _vm._v("(Nottingham: Apollos; Downers Grove: IVP Academic).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Rudolph, W. (1976), "), _c('i', [_vm._v("Haggai – Sacharja 1–8/9–14 – Maleachi")]), _vm._v(", KAT XIII/4 (Gütersloh: Gütersloher Verlagshaus Mohn).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Ryken, L. (1984), "), _c('i', [_vm._v("How to Read the Bible as Literature ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Scott, R. B. Y. (1971), "), _c('i', [_vm._v("The Way of Wisdom ")]), _vm._v("(New York: Macmillan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Sellin, E. and G. Fohrer (1968), "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(", trans. D. E. Green (Nashville: Abingdon Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Smith, J. M. P. in H. G. Mitchell, J. M. P. Smith and J. A. Bewer (1912), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi and Jonah")]), _vm._v(", ICC (Edinburgh: T. & T. Clark).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Smith, R. L. (1984), "), _c('i', [_vm._v("Micah – Malachi")]), _vm._v(", WBC 32 (Waco: Word).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Stead, M. R. (2009), "), _c('i', [_vm._v("Intertextuality of Zechariah 1 – 8")]), _vm._v(", Library of Hebrew Bible/Old Testament Studies 506 (New York: T. & T. Clark).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Stuhlmueller, C. (1988), "), _c('i', [_vm._v("Haggai & Zechariah: Rebuilding with Hope")]), _vm._v(", ITC (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Sweeney, M. A. (2000), "), _c('i', [_vm._v("The Twelve Prophets")]), _vm._v(", Berit Olam, vol. 2 (Collegeville, Minn.: Liturgical Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Tucker, G. M. (1977), ‘Prophetic Superscriptions and the Growth of a Canon’, in G. W. Coats and B. O. Long (eds.), "), _c('i', [_vm._v("Canon and Authority ")]), _vm._v("(Philadelphia: Fortress), 56–70.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Ulrich, E. et al. (1997), "), _c('i', [_vm._v("Discoveries in the Judaean Desert (Vol. XV): Qumran Cave 4 (The Prophets) ")]), _vm._v("(Oxford: Clarendon Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Van der Toorn, K. et al. (eds.) (1999), "), _c('i', [_vm._v("The Dictionary of Deities and Demons in the Bible")]), _vm._v(", 2nd edn (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Webb, B. G. (2003), "), _c('i', [_vm._v("The Message of Zechariah ")]), _vm._v("(Leicester/Downers Grove, Ill.: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Wenzel, H. (2011), "), _c('i', [_vm._v("Reading Zechariah with Zechariah 1:1–6 as the Introduction to the Entire Book")]), _vm._v(", Contribution to Biblical Exegesis & Theology, 59 (Leuven: Peeters).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Westermann, C. (1991), "), _c('i', [_vm._v("Prophetic Oracles of Salvation in the Old Testament")]), _vm._v(", trans. K. Crim (Louisville: Westminster John Knox).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Malachi")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Achtemeier, E. (1986), "), _c('i', [_vm._v("Nahum – Malachi")]), _vm._v(", Int (Atlanta: John Knox).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Andersen, F. I. and D. N. Freedman (1980), "), _c('i', [_vm._v("Hosea")]), _vm._v(", AB 24 (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("––– (1989), "), _c('i', [_vm._v("Amos")]), _vm._v(", AB 24A (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Baker, D. W. (2006), "), _c('i', [_vm._v("Joel, Obadiah, Malachi")]), _vm._v(", NIVAC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Baldwin, J. G. (1972), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi")]), _vm._v(", TOTC 28 (London/Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Bartlett, J. R. (1989), "), _c('i', [_vm._v("Edom and the Edomites")]), _vm._v(", JSOTSup 77 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Beale, G. K. (2004), "), _c('i', [_vm._v("The Temple and the Church’s Mission")]), _vm._v(", NSBT 17 (Leicester: Apollos; Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Berlin, A. (1994), "), _c('i', [_vm._v("Zephaniah")]), _vm._v(", AB 25A (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Bienkowski, P. (2001), ‘New Evidence on Edom in the Neo-Babylonian and Persian Periods’, in J. A. Dearman and M. P. Graham (eds.), "), _c('i', [_vm._v("The Land That I Will Show You: Essays in Honor of J. Maxwell Miller")]), _vm._v(", JSOTSup 343, (Sheffield: Sheffield Academic Press), 198–213.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Brueggemann, W. (1982), "), _c('i', [_vm._v("The Creative Word: Canon as a Model for Biblical Education ")]), _vm._v("(Philadelphia: Fortress).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Calvin, J. (1979), "), _c('i', [_vm._v("Commentaries on the Twelve Minor Prophets ")]), _vm._v("(repr.), trans. J. Owen (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Cathcart, K. J. and R. P. Gordon (1989), "), _c('i', [_vm._v("The Targum of the Minor Prophets")]), _vm._v(", The Aramaic Bible 14 (Wilmington, Del.: Michael Glazier).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Clark, D. J. and H. A. Hatton (2002), "), _c('i', [_vm._v("A Handbook on Haggai, Zechariah, and Malachi")]), _vm._v(", UBS Handbook Series (New York: United Bible Societies).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Collins, J. J. (1984), ‘The Message of Malachi’, "), _c('i', [_vm._v("TBT")]), _vm._v(": 209–215.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Craigie, P. C. (1985), "), _c('i', [_vm._v("Twelve Prophets")]), _vm._v(", DSBOT, vol. 2 (Philadelphia: Westminster).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Dentan, R. C. and W. L. Sperry (1956), ‘Malachi’, in G. A. Buttrick (ed.), "), _c('i', [_vm._v("The Interpreter’s Bible")]), _vm._v(", vol. 6 (New York: Abingdon), 1121–1144.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Durham, J. I. (1987), "), _c('i', [_vm._v("Exodus")]), _vm._v(", WBC 3 (Waco: Word).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Ferreiro, A. (ed.) (2003), "), _c('i', [_vm._v("Ancient Christian Commentary on Scripture: The Twelve Prophets")]), _vm._v(", vol. 14 (Downers Grove, Ill.: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Fishbane, M. (1983), ‘Form and Reformulation of the Biblical Priestly Blessing’, "), _c('i', [_vm._v("JAOS ")]), _vm._v("103: 115–121.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("––– (1985), "), _c('i', [_vm._v("Biblical Interpretation in Ancient Israel ")]), _vm._v("(Oxford: Clarendon Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Fuller, R. E. (1991), ‘Text-Critical Problems in Malachi 2:10–16’, "), _c('i', [_vm._v("JBL ")]), _vm._v("110: 47–57.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Garland, D. E. (1987), ‘A Biblical View of Divorce’, "), _c('i', [_vm._v("RevExp ")]), _vm._v("84: 419–432.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Glazier-McDonald, B. (1987), "), _c('i', [_vm._v("Malachi: The Divine Messenger")]), _vm._v(", SBLDS 98 (Atlanta: Scholars Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Gordon, R. P. (1994), "), _c('i', [_vm._v("Studies in the Targum of the Twelve Prophets")]), _vm._v(", VTSup 51 (Sheffield: JSOT Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Hanson, P. D. (1986), "), _c('i', [_vm._v("The People Called: The Growth of Community in the Bible ")]), _vm._v("(San Francisco: Harper & Row).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Hill, A. E. (1998), "), _c('i', [_vm._v("Malachi")]), _vm._v(", AB 25D (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Hoglund, K. (1994), ‘Edomites’, in A. J. Hoerth, G. L. Mattingly and E. M. Yamauchi (eds.), "), _c('i', [_vm._v("Peoples of the Old Testament World ")]), _vm._v("(Grand Rapids: Baker), 335–347.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Hugenberger, G. P. (1998), "), _c('i', [_vm._v("Marriage as a Covenant ")]), _vm._v("(Grand Rapids: Baker), first published as "), _c('i', [_vm._v("Marriage as Covenant: A Study of Biblical Law and Ethics Governing Marriage, Developed from the Perspective of Malachi")]), _vm._v(", VTSup 52 (Leiden: Brill, 1994).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Isbell, C. D. (1980), "), _c('i', [_vm._v("Malachi ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Jones, D. R. (1962), "), _c('i', [_vm._v("Haggai, Zechariah and Malachi")]), _vm._v(", Torch Bible Commentaries (London: SCM).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Keil, C. F. (1975), "), _c('i', [_vm._v("Commentary on the Twelve Prophets ")]), _vm._v("(repr.), trans. ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("J. Martin (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Klein, R. W. (1986), ‘A Valentine for Those Who Fear Yahweh: The Book of Malachi’, "), _c('i', [_vm._v("CurTM ")]), _vm._v("13: 143–152.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Kruse-Blinkenberg, L. (1967), ‘The Book of Malachi According to Codex Syro-Hexaplaris Ambrosianus’, "), _c('i', [_vm._v("ST")]), _vm._v(": 95–119.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Levine, B. A. (1993), "), _c('i', [_vm._v("Numbers 1 – 20")]), _vm._v(", AB 4 (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Mallone, G. (1981), "), _c('i', [_vm._v("The Furnace of Renewal ")]), _vm._v("(Downers Grove: IVP).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Mason, R. (1977), "), _c('i', [_vm._v("The Books of Haggai, Zechariah and Malachi")]), _vm._v(", CBC (Cambridge: Cambridge University Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("––– (1990), "), _c('i', [_vm._v("Preaching the Tradition: Homily and Hermeneutics after the Exile ")]), _vm._v("(Cambridge: Cambridge University Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("McKenzie, J. L. (1968), "), _c('i', [_vm._v("Second Isaiah")]), _vm._v(", AB 20 (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("McKenzie, S. L. and H. W. Wallace (1983), ‘Covenant Themes in Malachi’, "), _c('i', [_vm._v("CBQ ")]), _vm._v("45: 549–563.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Merrill, E. H. (1994), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi ")]), _vm._v("(Chicago: Moody Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Meyers, C. L. and E. M. Meyers (1987), "), _c('i', [_vm._v("Haggai, Zechariah 1–8")]), _vm._v(", AB 25B (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("––– (1993), "), _c('i', [_vm._v("Zechariah 9 – 14")]), _vm._v(", AB 25C (New York: Doubleday).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("O’Brien, J. M. (1990), "), _c('i', [_vm._v("Priest and Levite in Malachi")]), _vm._v(", SBLDS 121 (Atlanta: Scholars Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("––– (2004), "), _c('i', [_vm._v("Nahum, Habakkuk, Zephaniah, Haggai, Zechariah, Malachi")]), _vm._v(", AOTC (Nashville: Abingdon).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Ogden, G. S. and R. R. Deutsch (1987), "), _c('i', [_vm._v("Joel & Malachi: A Promise of Hope – A Call to Obedience")]), _vm._v(", ITC (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Patterson, R. D. (1993), ‘Old Testament Prophecy’, in L. Ryken and T. Longman (eds.), "), _c('i', [_vm._v("A Complete Literary Guide to the Bible ")]), _vm._v("(Grand Rapids: Baker), 296–309.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Petersen, D. L. (1977), "), _c('i', [_vm._v("Late Israelite Prophecy: Studies in Deutero-Prophetic Literature and in Chronicles")]), _vm._v(", SBLMS 23 (Missoula, Mont.: Scholars Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("––– (1995), "), _c('i', [_vm._v("Zechariah 9 – 14 and Malachi")]), _vm._v(", OTL (Louisville: Westminster John Knox Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Pilch, J. J. and B. J. Malina (eds.) (1998), "), _c('i', [_vm._v("A Handbook of Biblical Social Value")]), _vm._v("s (Peabody, Mass.: Hendrickson).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Redditt, P. L. (1995), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi")]), _vm._v(", NCBC (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Rudolph, W. (1976), "), _c('i', [_vm._v("Haggai-Sacharja-Maleachi")]), _vm._v(", KAT, XIII/4 (Gütersloh: Gütersloher Verlagshaus Mohn).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Schuller, E. M. (1996), ‘The Book of Malachi’, in L. E. Keck (ed.), "), _c('i', [_vm._v("New Interpreter’s Bible")]), _vm._v(", vol. 7 (Nashville: Abingdon), 843–877.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Smith, G. A. (1943), "), _c('i', [_vm._v("The Book of the Twelve Prophets")]), _vm._v(", The Expositor’s Bible (repr.) (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Smith, J. M. P. in H. G. Mitchell, J. M. P. Smith and J. A. Bewer (1912), "), _c('i', [_vm._v("Haggai, Zechariah, Malachi and Jonah")]), _vm._v(", ICC (Edinburgh: T. & T. Clark).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Smith, R. L. (1984), "), _c('i', [_vm._v("Micah – Malachi")]), _vm._v(", WBC 32 (Waco: Word). Stuart, D. (1998), ‘Malachi’, in T. E. McComiskey (ed.), "), _c('i', [_vm._v("The Minor Prophets")]), _vm._v(", vol. 3 (Grand Rapids: Baker), 1245–1396.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Sweeney, M. A. (2000), "), _c('i', [_vm._v("The Twelve Prophets")]), _vm._v(", Berit Olam, vol. 2 (Collegeville, Minn.: Liturgical Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Tate, M. E. (1987), ‘Questions for Priests and People in Malachi 1:2 – 2:16’, "), _c('i', [_vm._v("RevExp")]), _vm._v(": 391–407.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Taylor, R. A. and E. R. Clendenen (2004), "), _c('i', [_vm._v("Haggai, Malachi")]), _vm._v(", NAC 21A (Nashville: Broadman & Holman).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Tucker, G. M. (1977), ‘Prophetic Superscriptions and the Growth of a Canon’, in G. W. Coats and B. O. Long (eds.), "), _c('i', [_vm._v("Canon and Authority ")]), _vm._v("(Philadelphia: Fortress), 56–70.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Ulrich, E. et al. (1997), "), _c('i', [_vm._v("Discoveries in the Judaean Desert (Vol. XV): Qumran Cave 4 (The Prophets) ")]), _vm._v("(Oxford: Clarendon Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("VanGemeren, W. A. (1990), "), _c('i', [_vm._v("Interpreting the Prophetic Word ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Verhoef, P. A. (1987), "), _c('i', [_vm._v("The Books of Haggai and Malachi")]), _vm._v(", NICOT (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Watts, J. D. W. (1987), ‘Introduction to the Book of Malachi’, "), _c('i', [_vm._v("RevExp ")]), _vm._v("84: 873–881.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Wells, C. R. (1987), ‘The Subtle Crisis of Secularism: Preaching the Burden of Israel’, "), _c('i', [_vm._v("CTR")]), _vm._v(": 39–61.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Westermann, C. (1969), "), _c('i', [_vm._v("Isaiah 40 – 66")]), _vm._v(", OTL, trans. D. M. G. Stalker (Philadelphia: Westminster).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("––– (1991), "), _c('i', [_vm._v("Basic Forms of Prophet Speech")]), _vm._v(", trans. H. C. White (Louisville: Westminster John Knox Press).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Wolf, H. (1976), "), _c('i', [_vm._v("Haggai and Malachi")]), _vm._v(", EvBC (Chicago: Moody).")])])])])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 78
// module chunks = 0